module.exports = __webpack_public_path__ + "f71c79009e921f0389f1a8fba4c62748.jpg";